// extracted by mini-css-extract-plugin
var _1 = "_odYY";
var _2 = "zGHUZ";
export { _1 as "base", _2 as "button" }
